import script from "./DiagnosticICD10CodeAutocomplete.vue?vue&type=script&setup=true&lang=js"
export * from "./DiagnosticICD10CodeAutocomplete.vue?vue&type=script&setup=true&lang=js"

import "./DiagnosticICD10CodeAutocomplete.vue?vue&type=style&index=0&id=075dd05b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-075dd05b"]])

export default __exports__